import { articles } from '@/mocks/melons';

const pads = ['text-primary-600', 'text-accent-700', 'text-secondary-600', 'text-foreground-400'];

export default function Collections() {
  const list = articles.filter((a) => a.series === 'collection');

  return (
    <section id="collections" className="scroll-mt-20 border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="container-page">
        <div className="flex flex-col items-start gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-900">
            <i className="ri-file-list-3-line" aria-hidden="true" />
            Feature Recap · 精华总结
          </span>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <h2 className="text-2xl font-bold text-foreground-950 md:text-[34px]">
              瓜田盘点<span className="ml-2 text-primary-600">专题合集</span>
            </h2>
            <a href="/about" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800">
              了解盘点标准
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>
          <p className="max-w-2xl text-sm text-foreground-600 md:text-[15px]">
            按事件时间线与来龙去脉整理的专题内容，覆盖带货、圈内、品牌与平台新规，帮你把散落的碎片拼成一张完整的瓜图。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-5">
          {list.map((a, i) => (
            <a
              key={a.id}
              href={`/post/${a.id}`}
              className="group grid grid-cols-1 gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-4 transition-all hover:border-accent-300 md:grid-cols-12 md:items-center md:p-5"
            >
              <span className={`hidden font-heading text-6xl font-black leading-none md:col-span-1 md:block ${pads[i % pads.length]}`}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="md:col-span-8">
                <div className="flex flex-wrap items-center gap-2 text-xs">
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-semibold text-primary-700">{a.categoryName}</span>
                  <span className="inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-book-2-line" aria-hidden="true" />{a.readMin} 分钟读完
                  </span>
                  <span className="inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-eye-line" aria-hidden="true" />{a.viewsText}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[22px]">
                  {a.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.summary}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
                  阅读完整盘点
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </div>
              <div className="md:col-span-3">
                <img
                  src={a.image}
                  alt={a.title}
                  loading="lazy"
                  className="h-36 w-full rounded-lg object-cover object-top md:h-32"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}